import React, { Component } from "react";
import "./ContentSlider.css";
import Server from "./Server.js";
import { Link, Navigate } from "react-router-dom";
import { Tag } from "primereact/tag";

class ContentSlider extends Component {
  constructor(props) {
    super(props);
    this.Server = new Server();

    this.state = {
      absoluteUrl: this.Server.getAbsoluteUrl(),
    };
  }

  render() {
    return (
      <div
        style={{
          direction: "rtl",
          paddingRight: 16,
          paddingLeft: 16,
          fontSize: 14,
          marginTop: 15,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: "bold",
          }}
        >
          <div>
            <div style={{ display: "flex", alignItems: "baseline" }}>
              <div
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor: "orange",
                  marginLeft: 5,
                }}
              ></div>

              <span>{this.props.title}</span>
            </div>
          </div>
          <div>
            <Link
              style={{ position: "relative", textAlign: "left" }}
              to={`${process.env.PUBLIC_URL}/${this.props.showAllLink}`}
            >
              <span style={{ color: "rgb(34, 170, 88)" }}>مشاهده همه</span>
            </Link>
          </div>
        </div>

        <div className="container">
          {this.props.data.map((item, index) => {
            return (
              <Link
                to={`${process.env.PUBLIC_URL}/Shop?_id=${item._id}`}
                key={index}
              >
                <div className="cell">
                  <div className="child">
                    {item.image ? (
                      <div
                        style={{ textAlign: "center", position: "relative" }}
                      >
                        <img
                          src={
                            this.state.absoluteUrl +
                            item.image.split("public")[1]
                          }
                          style={{ maxWidth: "100%", height: 100 }}
                        />
                        {/* {item.payCount > 0 && (
                          <div
                            style={{ position: "absolute", top: 0, left: 0 }}
                          >
                            <Tag
                              severity={
                                item.payCount > 0
                                  ? item.payCount > 100
                                    ? "success"
                                    : "info"
                                  : "warning"
                              }
                            >
                              {item.payCount} خریدار
                            </Tag>
                          </div>
                        )} */}
                      </div>
                    ) : (
                      <div
                        style={{ textAlign: "center", position: "relative" }}
                      >
                        <img
                          src="https://archive.org/download/no-photo-available/no-photo-available.png"
                          style={{ maxWidth: "100%", height: 100 }}
                        />
                        {/* <div style={{ position: "absolute", top: 0, left: 0 }}>
                          <Tag
                            severity={
                              item.payCount > 0
                                ? item.payCount > 100
                                  ? "success"
                                  : "info"
                                : "warning"
                            }
                          >
                            {item.payCount} خریدار
                          </Tag>
                        </div> */}
                      </div>
                    )}
                    <div>{item.title}</div>

                    <div className="ellipsis" style={{fontSize:12}}> {item.desc} </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    );
  }
}

export default ContentSlider;
